import { useClientSide } from '@carvana/merch-react-hooks';

// TODO: update to use useSearchParams when VDP is fully on app router (no more /vehicle-v1 page router version)
function SimulateSpinnerCrash() {
  const isClientSide = useClientSide();
  const searchParams = new URLSearchParams(
    window.location.search.replace(/^\?+/, '')
  );

  if (isClientSide && searchParams.has('crashSpinner')) {
    // @ts-ignore
    window.xyz.dummy();
  }

  return null;
}

export default SimulateSpinnerCrash;
